// --------------------------------------------------------------------------
// #57 – List block
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    if (window.matchMedia) {
        var mq = window.matchMedia('screen and (max-width: 560px)');
    }

    var definitionList = context.find('[data-binding="activites-list"]');

    function mobileDefinitionList() {
        if (mq.matches) {
            definitionList.addClass('closed');

            definitionList.on('click', function (e) {
                e.preventDefault();
                $(this).toggleClass('closed').toggleClass('open');
            });
        } else {
            definitionList.off('click');
            definitionList.removeClass('closed').removeClass('open');
        }
    }

    function init() {
        if (mq.addListener) {
            mq.addListener(mobileDefinitionList);
            mobileDefinitionList();
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/activities/activity.js
// module id = 205
// module chunks = 0